var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    id: "photoshop",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C5F0",
    d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M2.4 24C2.4 12.07 12.07 2.4 24 2.4c11.93 0 21.6 9.67 21.6 21.6 0 11.93-9.67 21.6-21.6 21.6-11.93 0-21.6-9.67-21.6-21.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#31C5F0",
    fillRule: "evenodd",
    d: "M12 13.914c0-.126.269-.22.426-.22 1.223-.063 3.019-.094 4.9-.094 5.27 0 7.322 2.885 7.322 6.586 0 4.83-3.503 6.9-7.8 6.9-.393 0-.647-.01-.877-.018a14.977 14.977 0 0 0-.597-.013v7.303c0 .157-.063.22-.22.22H12.22c-.157 0-.22-.064-.22-.22V13.914Zm3.374 10.099c.439.03.784.03 1.537.03 2.226 0 4.318-.783 4.318-3.794 0-2.415-1.496-3.638-4.036-3.638-.753 0-1.474.03-1.82.063v7.338Zm14.353-.879c0-.627.502-1.38 2.007-1.38 1.224 0 2.47.314 3.316.816.188.063.282-.032.282-.188v-2.604c0-.125-.031-.282-.188-.376-.627-.282-1.779-.533-3.41-.533-3.324 0-5.237 2.038-5.237 4.485 0 2.195 1.129 3.512 3.826 4.798 1.913 1.004 2.352 1.6 2.352 2.29 0 .847-.627 1.474-2.132 1.474-1.255 0-2.638-.345-3.83-1.13-.125-.093-.22-.03-.22.158v2.791c0 .157.032.251.157.314.816.47 2.23.815 3.893.815 3.136 0 5.457-1.63 5.457-4.673 0-2.038-.94-3.418-3.92-4.861-2.008-1.035-2.353-1.505-2.353-2.195Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(19.623 16.79) scale(28.1648)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E17",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#0E0E17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshop);
export default __webpack_public_path__ + "static/media/photoshop.87b99ef9e5069e6801070cfc34ed6ba2.svg";
export { ForwardRef as ReactComponent };